import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import MobileItem from "../../../../../../../../components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "../../../../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import NumberCircle from "../../../../../../../../components/icons/NumberCircle";
import Badge from "../../../../../../../../components/Badge";
import CustomButton from "components/CustomButton";
import {WMSContext} from "../../../../../../context/WMSContext";
import {ReactComponent as InternalNoteIcon} from "assets/img/internalNote-green.svg"

import RemoveFromTrolleyAction from "components/WMS/Mobile/WmsItemList/components/RemoveFromTrolleyAction";
import WmsItemInformationDrawer from "components/WMS/Mobile/WmsItemList/components/WmsItemInformationDrawer";
import InternalNote from "../../../../../../../picking/order/components/OrderActivities/InternalNote";

DisplayItemList.propTypes = {
    currentContainer: PropTypes.object.isRequired,
    refreshTrolley: PropTypes.func,
    inSorting: PropTypes.bool,
    onManualValidate: PropTypes.func,
};

function DisplayItemList({currentContainer, refreshTrolley = () => {}, inSorting = false, onManualValidate = () => {}}) {
    const [selectedWmsItem, setSelectedWmsItem] = useState(null);

    const {currentMember, currentOrganization} = useContext(WMSContext);

    const manualValidationEnabled = inSorting && currentOrganization?.wmsSortingManualValidation === true;

    const handleCloseItemInformationDrawer = () => {
        setSelectedWmsItem(null)
    }

    const getInternalNote = (item) => {
        let allNote = [...(item.lineItem.order.notes ?? [])]

        let internalNotes = [...allNote.filter(note => note.noteType === 'internal_note')]

        if (0 === internalNotes.length) return [];

        internalNotes.sort((itemA, itemB) => {
            let dateA = Date.parse(itemA.createdAt), dateB = Date.parse(itemB.createdAt);
            return (dateA < dateB) - (dateA > dateB);
        });

        return internalNotes;
    }

    useEffect(() => {
        handleCloseItemInformationDrawer()
    }, [currentContainer]);

    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {currentContainer.wmsItems.map((item) => {
                const internalNotes = getInternalNote(item)

                return (
                    <MobileItem key={item.id} onClick={() => setSelectedWmsItem(item)}>
                        <MobileItem.LeftSide
                            title={item.lineItem.name}
                            subtitle={
                                <>
                                    {item.lineItem.options?.map(option => option.value[`${currentMember?.locale}`]).join(' · ')}
                                </>
                            }
                            underTitle={
                                <Badge
                                    isBold={false}
                                    label={<span>{item.barcode}</span>}
                                    color={"info"}
                                    size={"large"}
                                    rounded
                                />
                            }
                        >
                            <ThumbnailAndNotification
                                link={item.lineItem.pictures[0]}
                                alt={"Wishibam logo"}>
                                <NumberCircle number={item.count}/>
                            </ThumbnailAndNotification>
                        </MobileItem.LeftSide>
                        <MobileItem.RightSide>
                            <Grid
                                container
                                gap={'8px'}
                                alignItems={'center'}
                            >
                                <Badge color={'info'}
                                       rounded
                                       isBold={false}
                                       size={'large'}
                                >
                                    {item.shipmentType}
                                </Badge>
                                {0 < internalNotes.length && (
                                    <InternalNoteIcon/>
                                )}
                            </Grid>

                        </MobileItem.RightSide>
                    </MobileItem>
                )
            })}

            <WmsItemInformationDrawer
                selectedWmsItem={selectedWmsItem}
                handleClose={handleCloseItemInformationDrawer}
            >
                {selectedWmsItem && (
                    <Grid container direction={'column'}>
                        <InternalNote items={getInternalNote(selectedWmsItem)} order={selectedWmsItem?.lineItem.order} onlyDisplayType={"internal_note"} />
                    </Grid>
                )}

                <Grid container direction={'column'} spacing={2}>
                    {manualValidationEnabled && (
                        <Grid item>
                            <CustomButton
                                fullWidth
                                onClick={() => {
                                    handleCloseItemInformationDrawer();
                                    onManualValidate(selectedWmsItem);
                                }}
                            >
                                <FormattedMessage id={"wms.sorting.manualValidation.button"}/>
                            </CustomButton>
                        </Grid>
                    )}
                    <Grid item>
                        <RemoveFromTrolleyAction
                            selectedWmsItem={selectedWmsItem}
                            onRemoveFromTrolley={() => refreshTrolley()}
                            handleCloseDrawer={handleCloseItemInformationDrawer}
                        />
                    </Grid>
                </Grid>
            </WmsItemInformationDrawer>
        </div>
    );
}

export default DisplayItemList;
